import APIKit from "../Allapis/Apikit/apikit";

export const getDocumentsDynamic = async (id) => {
  console.log("API Called with id:", id);
  const endpoint = id ? `/admin/documents/${id}` : `/admin/documents`;
  // console.log("Using endpoint:", endpoint);
  const res = await APIKit.get(endpoint);
  // console.log("Response received:", res);
  return res.data;
};

export const createDocumentsDynamic = async (values) => {
  const res = await APIKit.post(`/admin/documents`, values);
  return res.data;
};

export const updateDocumentsDynamic = async (id, values) => {
  const res = await APIKit.put(`/admin/documents/${id}`, values);
  return res.data;
};

export const deleteDocumentsDynamic = async (document_id) => {
  console.log("Deleting document with id:", document_id);
  const res = await APIKit.delete(`/admin/documents/${document_id}`);
  console.log("Delete response:", res);
  return res.data;
};
